import { api } from '@/lib/api'
import { notifyAppointmentStylist } from '@/lib/api/appointments'

export { notifyAppointmentStylist }

export async function fetchStylistSchedule() {
  const { data } = await api.get('/workspace/schedule')
  return data.data
}

export async function fetchStylistLive() {
  const { data } = await api.get('/workspace/live')
  return data.data
}

/**
 * @param {{ from?: string, to?: string }} [options]
 */
export async function fetchMyCommissionSummary(options = {}) {
  const params = {}
  if (options.from) params.from = options.from
  if (options.to) params.to = options.to

  const { data } = await api.get('/workspace/commission-summary', { params })
  return data.data
}

/**
 * @param {{ from?: string, to?: string }} [options]
 */
export async function fetchMyTipsSummary(options = {}) {
  const params = {}
  if (options.from) params.from = options.from
  if (options.to) params.to = options.to

  const { data } = await api.get('/workspace/tips-summary', { params })
  return data.data
}

/**
 * @param {number} appointmentId
 * @param {number} appointmentServiceId
 * @param {'in_chair' | 'done'} status
 */
export async function updateStylistServiceStatus(appointmentId, appointmentServiceId, status) {
  const { data } = await api.post(
    `/workspace/appointments/${appointmentId}/services/${appointmentServiceId}/status`,
    { status },
  )
  return data.data.appointment
}

/**
 * @param {{ title: string, starts_at: string, ends_at: string, notes?: string }} payload
 */
export async function requestStylistBlockout(payload) {
  const { data } = await api.post('/workspace/blockout-requests', payload)
  return data.data
}

export async function markStylistNotificationRead(notificationId) {
  const { data } = await api.post(`/workspace/notifications/${notificationId}/read`)
  return data.data
}

/**
 * @param {{ endpoint?: string, platform?: string }} payload
 */
export async function registerStylistPushStub(payload = {}) {
  const { data } = await api.post('/workspace/push-register', payload)
  return data.data
}
